

const state = () => ({
    roles: [],
    permissions: [],
    savedPermissions: [],
})

export default state
